export const DAT_DB_NAME: string = 'dat-local';

export class DatDbConfig {
    dbs?: string[] = [DAT_DB_NAME];
    db?: string = DAT_DB_NAME;
    defaultDb?: string = DAT_DB_NAME;
}
